import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LoadingSpinnerComponent } from '../../../loading-spinner/loading-spinner.component';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormMode } from '../../../../core/constants';

@Component({
  selector: 'app-add-catalog-item-dialog',
  standalone: false,
  templateUrl: './add-catalog-item-dialog.component.html',
})
export class AddCatalogItemDialogComponent {
  loadingSpinnerRef: MatDialogRef<LoadingSpinnerComponent> | undefined;
  catalogId: string;
  //item: Partial<CatalogItem> = CatalogItem.createEmpty();
  itemId: string = '';
  FormMode = FormMode;

  constructor(
    public dialogRef: MatDialogRef<AddCatalogItemDialogComponent>,
    public sanitizer: DomSanitizer,
    public loadingSpinnerDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      catalogId: string;
      itemId: string;
    },
  ) {
    this.catalogId = data.catalogId;
    if (!this.catalogId || this.catalogId == '') {
      throw 'Catalog ID is required';
    }
  }

  handleSaved() {
    this.loadingSpinnerRef?.close();
    this.dialogRef.close({});
  }

  handleCancelled() {
    this.loadingSpinnerRef?.close();
    this.dialogRef.close();
  }
}
